<template>
  <div class="input-question-view">
<!--    <div class="question-desc-view">{{questioninfo.desc}}</div>-->
    <template
      v-if="questionData.content_audio&&questionData.content_audio!=''&&questionData.content_audio!=null">
      <div class="input-play-btn"
           @click="playcontent(questionData.content_audio)">
        <div>听力材料</div>
      </div>
    </template>
    <div class="input-question-info-view">
      <div class="input-question-contents-view">
        <div id="parent1" class="input-contentinfo-view"></div>
      </div>
      <div class="input-question-options-content-view" v-if="!showanswertype">
        <div style="display: flex;flex-direction: row">
          <template v-for="(item,index) in questioninfo.optionsArr[answerindex]" v-if="questioninfo.optionsArr">
            <div class="input-options-item-text" v-if="item.isClick" @click="inputFill(index)">{{ item.option }}</div>
          </template>
        </div>
        <el-button class="reset-btn" @click="resetInput">重置</el-button>
      </div>

    </div>

    <audio ref="inputfillmusic" controls="controls" style="display: none"
           preload="auto" @ended="playend">
      <source :src="audiourl" type="audio/mpeg">
    </audio>
  </div>
</template>

<script>
  import apiUtil from "@/api/apiUtils"
  import Apis from "@/api"
  import Vue from 'vue';

  export default {
    name: "inputfillquestion",
    data() {
      return {
        questioninfo: {},
        optionindex: 0,
        answerindex: 0,
        showkeyboard: true,
        layout: {
          _meta: {
            "tab": {key: "\t", text: "Tab", width: 60, classes: "control"},
            "shiftl": {keySet: "shifted", text: "Shift", width: 100, classes: "control"},
            "shiftr": {keySet: "shifted", text: "Shift", width: 100, classes: "control"},
            "caps": {keySet: "capsed", text: "Caps lock", width: 80, classes: "control"},
            "space": {key: " ", text: "Space", width: 180},
            "enter": {key: "\r\n", text: "Enter", width: 80, classes: "control"},
            "backspace": {func: "backspace", classes: "control backspace", width: 65},
            "accept": {func: "accept", text: "OK", classes: "control featured btntextbg"},
            "next": {func: "next", text: "Next", classes: "control featured btntextbg"}
          },

          default: [
            "` 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
            "{tab} q w e r t y u i o p [ ] \\",
            "{caps} a s d f g h j k l ; ' {enter}",
            "{shiftl} z x c v b n m , . / {shiftr}",
            "{next} {space} {accept}"
          ],
          shifted: [
            "~ ! @ # $ % ^ & * ( ) _ + {backspace}",
            "{tab} Q W E R T Y U I O P { } |",
            "{caps} A S D F G H J K L : \" {enter}",
            "{shiftl} Z X C V B N M < > ? {shiftr}",
            "{next} {space} {accept}"
          ],

          capsed: [
            "` 1 2 3 4 5 6 7 8 9 0 - = {backspace}",
            "{tab} Q W E R T Y U I O P [ ] \\",
            "{caps} A S D F G H J K L ; ' {enter}",
            "{shiftl} Z X C V B N M , . / {shiftr}",
            "{next} {space} {accept}"
          ]
        },
        options: {
          useKbEvents: true,
          preventClickEvent: true
        },
        input: null,
        showoption: false,
        showanswertype: false,
        isCanClick: false,
        showanswerdialog: false,
        audiourl: "",
        showdesc: true,
        localindex: 0,
        totalindex: 0,
        contentplay: false,
        descplay: false
      }
    },
    props: {
      questionData: {
        type: Object,
        default: function () {
          return {}
        }
      },
      isShowHead: {
        type: Boolean,
        default: true
      }
    },
    watch: {
      "questionData": function () {
        this.initData()
      }
    },
    mounted() {
      let _this = this;
      this.$nextTick(() => {
        _this.initData()
      })
    },
    methods: {
      showdescbtn() {
        if (this.showdesc == false) {
          this.showdesc = true;
          this.$refs.inputfillmusic.pause()
        }
      },
      initData() {
        this.questioninfo = this.paraseData(JSON.parse(JSON.stringify(this.questionData)));
      },
      accept(text) {
        // alert("Input text: " + text);
        // this.hide();
        this.isCanClick = true;
        this.changeAnswer(text)
        this.input.value = ""
        this.checkanswer()
      },
      hide() {
        this.showkeyboard = false;
      },
      show(e) {
        this.input = e.target;
        if (!this.showkeyboard)
          this.showkeyboard = true
      },

      paraseData(questiondata) {
        var that = this;
        var parent1 = document.getElementById('parent1');
        if (parent1) {
          parent1.innerHTML = "";
        }
        var questioninfo = {}
        this.optionindex = 0;
        var options = []
        questiondata.answers = questiondata.answer.split("|")
        if (questiondata.answers != null) {
          questiondata.answers.forEach(item => {
            item.replace(/\\n/g, "<br>")
            var arr = that.randomSort(item.split(""))
            var arrs = []
            arr.forEach(aitem => {
              arrs.push({isClick: true, option: aitem})
            })
            options.push(arrs)
          })
        }
        if(!questiondata.ontionsArr){
          questiondata.optionsArr = options
        }
        var thisCount = 0;
        thisCount = this.substring(questiondata.content, "||")
        for (var i = 0; i < thisCount; i++) {
          var idinfo = "answer" + i;
          var html = ""
          if (i == 0) {
            html = "<span id='" + idinfo + "' class='answer-t-view fillanswer' style='background:#5D79FA;color:#fff;border-bottom:2px solid #fff;' @click='test'>" + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + "</span>"
          } else {
            html = "<span id='" + idinfo + "' class='answer-t-view fillanswer' style='border-bottom:2px solid #131313;color:#131313' @click='test'' @click='test'>" + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + "</span>"
          }
          // html = "<span id='" + idinfo + "' class='answer-t-view fillanswer' style='border-bottom:2px solid #8c939d;color:#131313' @click='test'>" + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + "</span>"
          if (questiondata.useroption && questiondata.useroption.length > 0) {
            if (questiondata.useroption[i].trim() != "") {
              html = "<span id='" + idinfo + "' class='answer-t-view fillanswer' style='border-bottom:2px solid #8c939d;color:#131313' @click='test'>" + questiondata.useroption[i] + "</span>"
            }
          }
          questiondata.content = questiondata.content.replace("||", html)
        }
        var thiscontent = questiondata.content.replace(/\\n/g, "</br>")
        thiscontent = thiscontent.split("</br>");
        var strcontent = ""
        for (var j = 0; j < thiscontent.length; j++) {
          var contentinfo = thiscontent[j];
          if (contentinfo.indexOf("<img>") > -1) {
            var contentitems = contentinfo.split("<img>")
            for (var k = 0; k < contentitems.length; k++) {
              if (contentitems[k].indexOf(".jpeg") > -1 || contentitems[k].indexOf(".png") > -1 || contentitems[k].indexOf(".jpg") > -1) {
                var imgurl = apiUtil.getBaseUrl() + contentitems[k]
                strcontent += "<img style='width: 180px;height: 180px' src='" + imgurl + "'/>";
              } else {
                strcontent += contentitems[k]
              }
            }
            strcontent += "</br>"
          } else {
            strcontent += contentinfo + "</br>"
          }
        }
        questiondata.content = "<div>" + strcontent + "</div>"
        questioninfo = questiondata
        setTimeout(() => {
          var MyComponent1 = Vue.extend({
            template: questiondata.content,
            data() {
              return {
                allcount: thisCount
              }
            },
            methods: {
              test(e) {
                if (!that.answerfinish && !that.questionfinish) {
                  that.clickthis(e.currentTarget.id.replace("answer", ""), "1")
                }
              },
              playaudio(e) {
                that.playaudio(e)
              },
              chosestyle(i) {
                if (!that.answerfinish && !this.questionfinish) {
                  var fillanswers = document.getElementsByClassName("fillanswer")
                  if (that.questioninfo.answers[i] == fillanswers[i].innerHTML) {
                    fillanswers[i].setAttribute("style", "background:#5D79FA;color:#fff;border-bottom:2px solid #fff;")
                  } else {
                    that.trueflag = false;
                    fillanswers[i].setAttribute("style", "border-bottom:2px solid #131313;color:#131313")
                    fillanswers[i].innerHTML = fillanswers[i].innerHTML + "(" + that.questioninfo.answers[i] + ")"
                  }
                }
                that.playaudiotype(that.trueflag)
              }
            }
          });
          that.component = new MyComponent1().$mount();
          var parent = document.getElementById('parent1');
          parent.innerHTML = "";
          parent.appendChild(that.component.$el);
          if(that.questioninfo.useroption&&that.questioninfo.useroption.length>0){
            that.inputUseranswer()
          }
        }, 100)
        this.$nextTick(() => {
          this.$refs.inputtext.focus()
        })
        console.log(questioninfo)
        return questioninfo;
      },
      inputUseranswer(){
        this.questioninfo.useroption.forEach((item,index)=>{
          document.getElementById(("answer" + index)).innerHTML = item;
          document.getElementById(("answer" + index)).setAttribute("style", "color:#131313;border-bottom:2px solid #8c939d;");
        })
      },
      inputFill(index) {
        this.questioninfo.optionsArr[this.answerindex][index].isClick = false
        var isfinish = true
        this.questioninfo.optionsArr[this.answerindex].forEach(item => {
          if (item.isClick) {
            isfinish = false
          }
        })
        var chat = document.getElementById(("answer" + this.answerindex)).innerHTML.trim().replace("&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;", "")
        document.getElementById(("answer" + this.answerindex)).innerHTML = chat + this.questioninfo.optionsArr[this.answerindex][index].option
        this.$forceUpdate()
        this.isCanClick = true;
        if (isfinish) {
          this.answernext()
          this.checkanswer()
        }

      },
      resetInput(){
        this.questioninfo.optionsArr[this.answerindex].forEach(item => {
          item.isClick = true
        })
        document.getElementById(("answer" + this.answerindex)).innerHTML ="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;"
      },
      substring(text, chrt) {
        var str = text;
        var arr = str.split(chrt)
        return arr.length - 1
      },
      changeAnswer(answer) {
        if (answer) {
          document.getElementById(("answer" + this.answerindex)).innerHTML = answer.ResetBlank();
          document.getElementById(("answer" + this.answerindex)).setAttribute("style", "color:#131313;border-bottom:2px solid #131313;");
          this.answerindex += 1;
          if (this.answerindex >= this.questioninfo.answers.length) {
            this.answerindex -= 1;
          }
          var fillanswers = document.getElementsByClassName("fillanswer")
          for (var i = 0; i < fillanswers.length; i++) {
            if (this.answerindex == i) {
              fillanswers[i].setAttribute("style", "background:#5D79FA;border-bottom:2px solid #fff;")
            } else {
              fillanswers[i].setAttribute("style", "border-bottom:2px solid #131313;")
            }
          }
        }
      },
      clickthis(index) {
        var fillanswers = document.getElementsByClassName("fillanswer")
        for (var i = 0; i < fillanswers.length; i++) {
          if (index == i) {
            fillanswers[i].setAttribute("style", "background:#5D79FA;border-bottom:2px solid #fff;color:#fff")
          } else {
            fillanswers[i].setAttribute("style", "border-bottom:2px solid #8c939d;")
          }
        }

        this.answerindex = index * 1;
        this.$refs.inputtext.focus()

      },
      answernext() {
        this.answerindex += 1;
        if (this.answerindex >= this.questioninfo.answer.length) {
          this.answerindex = 0;
        }
        this.clickthis(this.answerindex)

      },
      checkanswer() {
        var that = this;
        var fillanswers = document.getElementsByClassName("fillanswer")
        var useroption = []
        for (var i = 0; i < fillanswers.length; i++) {
          useroption.push(fillanswers[i].innerText);
        }
        that.questioninfo.isfinish = true;
        that.questioninfo.useroption = useroption
        that.$emit("questionfinish", this.questioninfo)
      },
      playcontent() {
        var audiourl = apiUtil.getBaseUrl() + this.questioninfo.content_audio;
        this.$refs.inputfillmusic.src = audiourl;
        if (this.$refs.inputfillmusic.paused) {
          this.$refs.inputfillmusic.play();
          this.contentplay = true;
        }
      },

      playend() {
        this.descplay = false;
        this.contentplay = false;
      }
    },
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../assets/css/common.styl";
  .input-question-view {
    width 100%;
    height 100%;
  }

  .input-question-info-view {
    display flex;
    width 100%;
  }
  .input-play-btn {
    margin 10px ;
    width 240px;
    height 60px;
    display flex;
    background url("../../assets/img/question-device-bg.png")
    background-size 100% 100%;
    align-items center;
    color #5D79FA;
    font-size 30px;

    & > div {
      margin-left 80px;
    }
  }
  .input-question-contents-view {
    width 50%;
    height 100%;
    border-right 1px dashed #E5E5E5;
    border-radius 12px;
    background #fff;
  }

  .input-question-options-content-view {
    width 50%;
    height 100%;
    border-radius 12px;
    background #fff;
    display flex;
    margin auto;
    flex-direction column;
    align-items center;
    justify-content center;
  }
  .input-options-item-text {
    border 3px solid #000;
    padding 17px 29px;
    border-radius 12px;
    margin 20px;
    font-size 36px;
  }
  .input-question-options-content-view::-webkit-scrollbar {
    display block !important;
    width: 3px !important; /*高宽分别对应横竖滚动条的尺寸*/
    height: 2px !important;
  }

  .input-question-options-content-view::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
    border-radius: 10px !important;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2) !important;
    background: #5d79fa !important;
  }

  .input-question-options-content-view::-webkit-scrollbar-track { /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2) !important;
    border-radius: 10px !important;
    background: #EDEDED !important;
  }

  .input-contentinfo-view {
    width 98%;
    height 500px;
    display flex;
    text-align left;
    font-size 30px;
    color #131313;
    font-weight normal;
    overflow-y auto;
    margin 30px 15px 10px 15px;
  }

  .question-select-options-view {
    width 100%;
    display flex;
    flex-wrap wrap;
  }

  .input-option-item-view {
    border 3px solid #000;
    padding 17px 29px;
    border-radius 12px;
    margin 20px;
    font-size 36px;
  }

  .answer-t-view {
    line-height 50px;
    margin 10px 3px;
    background #ffffff;
    min-width 50px;
  }

  .keyboard-view {
    width 100%;
    margin 10px auto;
  }

  .vue-touch-keyboard .keyboard .key {
    height 40px;
    line-height 40px;
    font-size 18px;
  }

  .input-view {
    width 100%;
    margin 40px auto;
    border none;
    font-size 30px;
    text-align center;
  }

  input-view::-webkit-input-placeholder { /* Chrome/Opera/Safari */
    color #ffff00
  }

  .input-toast-view {
    width 100%;
    color #bdbdbd;
    font-size 24px;
  }

  .input-show-toast {
    width 487px;
    height 241px;
    background url("../../assets/img/fill-show-toast-bg.png")
    background-size 100% 100%;
    margin 0 auto;
  }

  .disable-btn {
    pointer-events: none;
    opacity 0.5
  }

  .input-bottom-view {
    width 100%;
    height 90px;
    position absolute;
    bottom 0;

    .input-finish-btn {
      width 50%;
      height 72px;
      font-size 36px;
      position absolute;
      left 25%;
      bottom 30px;
      border-radius 36px;
      background #5777FF;
      color #fff;
    }

    .input-finish-view {
      width 100%;
      height 90px;
      display flex;
      position absolute;
      bottom 0;
    }

    .answer-right-bottom-view img {
      margin-right 15px;
    }

    .answer-right-bottom-view {
      display flex;
      flex 1;
      height 100%;
      justify-content center;
      align-items center;
      color #fff;
      font-size 36px;
      background #92C761;
    }

    .input-finish-wrong {
      width: 100%;
      height 100%;
      display flex;
      justify-content center;
      align-items center;

      .answer-wrong-bottom-view {
        display flex;
        flex 1;
        height 100%;
        justify-content center;
        align-items center;
        color #fff;
        font-size 36px;
        background #F45578;
      }

      .answer-wrong-bottom-view img {
        margin-right 15px;
      }
    }
  }

  .input-show-answer-btn {
    font-size 24px;
    color #fff;
    padding 0 15px;
    display flex;
    height 100%;
    flex-direction column;
    justify-content center;
    align-items center;
    background #92C761;
  }

  .show-answer-dialog {
    width 100%;
    height 100%;
    position fixed;
    top 0;
    left 0;
    background #65d67a;
    z-index 2000;
    display flex;
    flex-direction column;
    justify-content center;
    align-items center;
  }

  .close-answer-dialog {
    background url("../../assets/img/answer-close-bg.png")
    background-size 100% 100%;
    width 180px;
    height 180px;
    position absolute;
    left -90px;
    top -90px;
  }

  .show-answer-content-view {
    width 88.5%;
    height 71.1%;
    background #fff;
    border-radius 12px;
    position relative;

    margin auto;
  }

  .dialog-toast-text {
    margin-top 24px;
    font-size 36px;
    color #131313;
    font-weight bold;
  }

  .input-show-answer-content-info {
    width 50%;
    height 96%;
    margin 1% auto;
    overflow-y auto;
    display flex;
    align-items center;
    flex-direction column;
    font-size 36px;
    text-align left;
    line-height 50px;
  }

  .btntextbg {
    background #5777FF !important;
    color #fff;
  }

  @media screen and (max-width: 1600px) {
    .input-question-info-view {
      top -6%;
    }

    .input-contentinfo-view {
      width 98%;
      height 380px;
      display flex;
      text-align left;
      font-size 24px;
      color #131313;
      font-weight normal;
      overflow-y auto;
      margin 30px 15px 10px 15px;
    }

    .input-bottom-view {
      width 100%;
      height 50px;
      position absolute;
      bottom 0;

      .input-finish-btn {
        width 50%;
        height 48px;
        font-size 24px;
        position absolute;
        left 25%;
        bottom 5px;
        border-radius 24px;
        background #5777FF;
        color #fff;
      }

      .input-finish-view {
        width 100%;
        height 50px;
        display flex;
        position absolute;
        bottom 0;
      }

      .answer-right-bottom-view img {
        width 40px;
        height 40px;
        margin-right 15px;
      }

      .answer-right-bottom-view {
        display flex;
        flex 1;
        height 100%;
        justify-content center;
        align-items center;
        color #fff;
        font-size 24px;
        background #92C761;
      }

      .input-finish-wrong {
        width: 100%;
        height 100%;
        display flex;
        justify-content center;
        align-items center;

        .answer-wrong-bottom-view {
          display flex;
          flex 1;
          height 100%;
          justify-content center;
          align-items center;
          color #fff;
          font-size 24px;
          background #F45578;
        }

        .answer-wrong-bottom-view img {
          width 40px;
          height 40px;
          margin-right 15px;
        }
      }
    }

    .vue-touch-keyboard .keyboard .key {
      height 2em;
      line-height 2em;
      font-size 1.6em;
    }

    .input-show-answer-btn {
      font-size 18px;
      color #fff;
      padding 0 15px;
      display flex;
      height 100%;
      flex-direction column;
      justify-content center;
      align-items center;
      background #92C761;
    }

    .input-show-answer-btn img {
      width 20px;
      height 20px;
    }
  }

  @media screen and (max-width: 1366px) {
    .input-question-info-view {
      display flex;
      width 88.54%;
      height 75%;
      position relative;
      left 5.73%;
      top -10%;
      border-radius 12px;
    }

    .input-contentinfo-view {
      width 98%;
      height 350px;
      display flex;
      text-align left;
      font-size 24px;
      color #131313;
      font-weight normal;
      overflow-y auto;
      margin 30px 15px 10px 15px;
    }

    .input-bottom-view {
      width 100%;
      height 50px;
      position absolute;
      bottom 5px;

      .input-finish-btn {
        width 50%;
        height 48px;
        font-size 24px;
        position absolute;
        left 25%;
        bottom 5px;
        border-radius 24px;
        background #5777FF;
        color #fff;
      }

      .input-finish-view {
        width 100%;
        height 50px;
        display flex;
        position absolute;
        bottom 0;
      }

      .answer-right-bottom-view img {
        width 40px;
        height 40px;
        margin-right 15px;
      }

      .answer-right-bottom-view {
        display flex;
        flex 1;
        height 100%;
        justify-content center;
        align-items center;
        color #fff;
        font-size 24px;
        background #92C761;
      }

      .input-finish-wrong {
        width: 100%;
        height 100%;
        display flex;
        justify-content center;
        align-items center;

        .answer-wrong-bottom-view {
          display flex;
          flex 1;
          height 100%;
          justify-content center;
          align-items center;
          color #fff;
          font-size 24px;
          background #F45578;
        }

        .answer-wrong-bottom-view img {
          width 40px;
          height 40px;
          margin-right 15px;
        }
      }
    }

    .prev-btn {
      position absolute;
      left 1%;
      top 50%;
      font-size 20px;
    }

    .next-btn {
      position absolute;
      right 1%;
      top 50%;
      font-size 20px;
    }

    .vue-touch-keyboard .keyboard .key {
      height 30px;
      line-height 30px;
      font-size 15px;
    }

    .input-show-answer-btn {
      font-size 18px;
      color #fff;
      padding 0 15px;
      display flex;
      height 100%;
      flex-direction column;
      justify-content center;
      align-items center;
      background #92C761;
    }

    .input-show-answer-btn img {
      width 20px;
      height 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/inputfillquestion.vue